import { useEffect, useState } from 'react'
import { Container, Row, Col, Card, Table, Form, InputGroup, Alert } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getStudents } from '../../../actions/studentActions'
import Loader from '../../../components/loaders/Loader'

export default function StudentList() {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const { students, loading, studentError } = useSelector(state => state.students)
    const [search, setSearch] = useState('')

    useEffect(() => {
        dispatch(getStudents())
    }, [dispatch])

    if (loading && (!students || students.length === 0)) return <Loader />

    if (studentError) return (
        <Container className='my-3 p-5'>
            <Alert variant='danger'>{studentError}</Alert>
        </Container>
    )

    const filtered = (students || []).filter(s => {
        if (!search) return true
        const q = search.toLowerCase()
        return (s.name || '').toLowerCase().includes(q) ||
               (s.groupName || '').toLowerCase().includes(q) ||
               (s.courseName || '').toLowerCase().includes(q)
    })

    return (
        <Container className='my-3 p-5'>
            <Row>
                <Col>
                    <h3 className='fw-bold mb-1'>{t('teacher.students.title')}</h3>
                    <p className='text-muted mb-0'>{students?.length || 0} {t('teacher.students.studentcount')}</p>
                </Col>
            </Row>

            <Row className='mt-3 mb-3'>
                <Col md={6} lg={4}>
                    <InputGroup>
                        <InputGroup.Text className='bg-white border-end-0'>
                            <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='#9ca3af' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
                                <circle cx='11' cy='11' r='8' /><line x1='21' y1='21' x2='16.65' y2='16.65' />
                            </svg>
                        </InputGroup.Text>
                        <Form.Control
                            placeholder={t('teacher.students.searchPlaceholder')}
                            className='border-start-0'
                            style={{ borderRadius: '0 10px 10px 0' }}
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                        />
                    </InputGroup>
                </Col>
            </Row>

            <Row>
                <Col>
                    <Card className='border-0 shadow-sm rounded-4'>
                        <Card.Body className='p-0'>
                            {filtered.length > 0
                                ? <Table hover responsive className='mb-0'>
                                    <thead className='bg-light'>
                                        <tr>
                                            <th className='fw-semibold' style={{ fontSize: '13px' }}>{t('global.name')}</th>
                                            <th className='fw-semibold' style={{ fontSize: '13px' }}>{t('global.group')}</th>
                                            <th className='fw-semibold' style={{ fontSize: '13px' }}>{t('global.course')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filtered.map(student => (
                                            <tr key={student.id} onClick={() => window.location.href = `/teacher/students/${student.id}`}
                                                style={{ cursor: 'pointer' }}>
                                                <td className='fw-semibold'>{student.name}</td>
                                                <td><span className='badge bg-light text-dark border'>{student.groupName}</span></td>
                                                <td className='text-muted'>{student.courseName}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                                : <div className='p-4 text-center'>
                                    <p className='text-muted mb-0'>
                                        {search ? t('global.results') : t('teacher.students.nostudents')}
                                    </p>
                                </div>
                            }
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    )
}
